import { gql } from '@apollo/client';

export const MUTATION_LOGIN_TRACKER = gql`
  mutation createLoginTracker($input: LoginTrackerInput!) {
    createLoginTracker(data: $input) {
      data {
        attributes {
          streakCounter
          day
        }
      }
    }
  }
`;
